import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DisciplineEducationalFormRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 2 &&
			indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			indexableFilters.some((_) => _.type === ParameterType.EDUCATIONAL_FORM)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DISCIPLINE_EDUCATIONAL_FORM_ROUTE,
			params: {
				discipline: this.extractPath(filters.find((_) => _.type === ParameterType.DISCIPLINES)),
				educational_form: this.extractPath(filters.find((_) => _.type === ParameterType.EDUCATIONAL_FORM))
			}
		};
	}
}
